import { render, staticRenderFns } from "./Paiement.vue?vue&type=template&id=1b57aab0&scoped=true&"
import script from "./Paiement.vue?vue&type=script&lang=js&"
export * from "./Paiement.vue?vue&type=script&lang=js&"
import style0 from "./Paiement.vue?vue&type=style&index=0&id=1b57aab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b57aab0",
  null
  
)

export default component.exports